import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import JsPdf from "jspdf";
import SignatureCanvas from 'react-signature-canvas';
import contractPF from '../../../Contracts/CARTA_AUTORIZACION_CARD/CARTA_AUTORIZACION(PF).jpg'
import contractPM from '../../../Contracts/CARTA_AUTORIZACION_CARD/CARTA_AUTORIZACION(PM).jpg'
import { Bounce } from 'react-activity';

const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const Contract = ({show, handleClose, data, uploadContract, Loading}) => {
    const [doc, setdoc] = useState('');
    const [pic, setpic] = useState('');
    const [contract, setContract] = useState('');
    const [contractB64, setcontractB64] = useState('');
    const ref = useRef(null);

    useEffect(() => {
        if(data && !isEmpty(data)){
            if(data.type === "personal"){
                setContract(contractPF)
            }else if(data.type === "business"){
                setContract(contractPM)
            }
        }
        generatePdf();
    }, [data, contract])

    const loadImage = (url) => {
        return new Promise((resolve) => {
          let img = new Image();
          img.onload = () => resolve(img);
          img.src = url;
        })
    }

    const isEmpty = (obj) => {
        return obj && Object.keys(obj).length === 0
    }

    const generatePdf = () =>{
        let checkData = !isEmpty(data)
        if(checkData){
            loadImage(contract).then((logo) => {
    /* ------------------------------- Propiedades ------------------------------ */
                var today = new Date();
                var doc = new JsPdf('portrait', 'mm', 'letter');
                doc.addImage(logo, 'JPG', 0, 0, 216,279 );
                doc.setFontSize(11);
    /* ---------------------------- Justificar texto ---------------------------- */
                var lMargin=30; //left margin in mm
                var rMargin=30; //right margin in mm
                var pdfInMM=215.9;  // width of A4 in mm
                var pageCenter=pdfInMM/2;
    /* ---------------------------- Justificar texto ---------------------------- */
                if(data.type === "personal"){
        
                    doc.text( String(today.getDate()).padStart(2, '0')   ,          120      ,   28.5); // DAY
                    doc.text( monthNames[today.getMonth()]               ,          145.5    ,   28.5); // MONTH
                    doc.text( String(today.getFullYear()).substring(2,4) ,          182.5    ,   28.5); // YEAR
                    doc.text(data.full_name, 82, 119.2); // Cuentahabiente
                    doc.text(data.card, 84, 125.8); // Numero de cuenta
                    doc.text(data.full_name, pageCenter, 246, 'center'); // Nombre completo
                    if(pic){
                        doc.addImage(pic, 'PNG',  pageCenter - (58/2), 180, 58, 10);
                    }
    
                } else if(data.type === "business") {
                    doc.text(`${data.full_name} como REPRESENTANTE`, 30, 60.9, 'left'); // representante
                    let razonSocial= doc.splitTextToSize(`${data.company_name} como RAZÓN SOCIAL`, (pdfInMM-lMargin-rMargin))
                    doc.text(razonSocial,30,65.8,'left')// razon social 
                    doc.text(String(today.getDate()).padStart(2, '0'),          125      ,   28.1); // DAY
                    doc.text(monthNames[today.getMonth()],                      141.5    ,   28.1); // MONTH
                    doc.text(String(today.getFullYear()).substring(2,4),        178.4    ,   28.1); // YEAR
                    doc.text(data.full_name, 80, 118.1); // Cuentahabiente
                    doc.text(data.card, 80, 124.2); // Numero de cuenta
                    doc.text(data.company_name, pageCenter, 219.4, 'center'); // Razon social
                    doc.text(data.full_name, pageCenter, 255.0, 'center'); // Nombre representante
                    if(pic){
                        doc.addImage(pic, 'PNG',  pageCenter - (58/2), 230, 58, 10);
                    }
                }
                // doc.save('report.pdf');
                setdoc(doc.output('bloburl'))
                setcontractB64(doc.output('dataurlstring').substring(51,doc.output('dataurlstring').length) )
            });
        }
    }

    const firmaCompletada = () => {
        var sefg = ref.current.getCanvas().toDataURL('image/png');
        setpic(sefg)
    }

    return ( 
        <Modal show={show} onHide={handleClose}>
             <Modal.Body>
                 <p>Contract</p>
                 <div style={{display:'flex', alignItems:'center', flexDirection:'column'}}>
                    <iframe src={doc} style={{marginBottom:'2em'}} width={240*2} height={360*1}   type="application/pdf"></iframe>

                    <div style={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                        <p >Signature</p>
                        <p onClick={()=>{ref.current.clear(); setpic('')}} className='link'>Clear ⟳</p>
                    </div>

                    <SignatureCanvas
                        penColor='blue'
                        canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                        onEnd={() => { firmaCompletada() }}
                        ref={ref} 
                        // backgroundColor='rgba(255,0,0,8)'
                    />

                </div>
                <br/>
                <center >
                    <Button onClick={() => { uploadContract(contractB64)}} 
                                    disabled={(pic)?(Loading)?true:false:true}
                                    className="signup-button" variant="primary">
                        {
                            (Loading)
                            ?<Bounce size={20} color={"#FFFFFF"} animating={true} />
                            :'Confirm'
                        }
                        
                    </Button>
                </center>
             </Modal.Body>
        </Modal>
     );
}
 
export default Contract;